/**
 * @module builder
 */

/**
 * Work-order display preferences that are owned by ACCOUNT settings
 * (Settings > Estimates > "Crew Display Options" —
 * packages/@paintscout/react-quote/src/options/QuoteOptions/QuoteOptions.tsx).
 *
 * These must never be inherited from baked content when a *new* quote is created:
 * not from a template (#20749) and not from the source quote when duplicating (#22179).
 * Option resolution gives any value stored on `quote.options` precedence over the
 * account value (see `getOverrideableOption`), so a stale snapshot silently wins forever.
 *
 * Deliberately excludes the template-driven work-order *structure* toggles that
 * `createQuote` pulls from the template (`showWorkOrderAreas`, `showWorkOrderSubstrates`,
 * `showWorkOrderAreaOptions`, ...) — those are shown as disabled ("set by the template")
 * in account settings and must keep tracking the template/source quote.
 */
export const ACCOUNT_MANAGED_WORK_ORDER_OPTIONS = [
  'hideWorkOrderMaterialCost',
  'hideWorkOrderVolumes',
  'hideWorkOrderDimensions',
  'hideWorkOrderClientContactInfo',
  'showWorkOrderClientNotes',
  'showWorkOrderViewDescriptions',
  'showWorkOrderItemTotals',
  'showWorkOrderAreaValues',
  'showWorkOrderFiles',
  'showWorkOrderCoats',
  'singleColumnWorkOrder',
  'useAllAreasForTotalDimensions'
] as const

export type AccountManagedWorkOrderOption = (typeof ACCOUNT_MANAGED_WORK_ORDER_OPTIONS)[number]
